export default __webpack_public_path__ + "static/media/Protein-BLAST-img.617893f4.svg";